import { render, staticRenderFns } from "./HomepageSearchButtons.vue?vue&type=template&id=2054d478&"
import script from "./HomepageSearchButtons.vue?vue&type=script&lang=js&"
export * from "./HomepageSearchButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseBtn: require('/usr/src/app/components/base/Btn.vue').default,SectionBaseSection: require('/usr/src/app/components/sections/BaseSection.vue').default})


/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
